import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { Unit, ListResponse } from '@/types';
import { Pagination } from '@/components';
import { EditFlat, TrashFlat } from '@/assets/icons';
import theme from '@/theme';

import { DeleteUnit, UpdateUnit } from '../components';

export interface UnitListProps {
  list?: ListResponse<Unit>;
  page: number;
  onChangePage(page: number): void;
}

const UnitsTable: React.FC<UnitListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentUnit, setCurrentUnit] = useState<Unit | null>(null);

  function openUpdateModal(unit: Unit) {
    setCurrentUnit(unit);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(unit: Unit) {
    setCurrentUnit(unit);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Код бюро</TableCell>
                <TableCell>Код</TableCell>
                <TableCell>Название</TableCell>

                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((unit) => {
                const { buro_code, code, name, id } = unit;

                return (
                  <TableRow key={id}>
                    <TableCell>{buro_code}</TableCell>
                    <TableCell>{code}</TableCell>
                    <TableCell>{name}</TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(unit)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(unit)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateUnit unit={currentUnit!} open={updateModalOpened} onClose={() => setOpenedUpdateModal(false)} />
      <DeleteUnit unit={currentUnit!} open={deleteModalOpened} onClose={() => setOpenedDeleteModal(false)} />
    </>
  );
};

export default UnitsTable;
